export default __webpack_public_path__ + "static/media/Helvetica-Oblique.5c03f243.ttf";